import styled from "styled-components/macro";

import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrAccordion from "UI/FnrAccordion/FnrAccordion";
import FnrOptionCards from "UI/FnrOptionCards/FnrOptionCards";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

import BackButton from "./BackButton/BackButton";

const customHelperText =
  "Creating a new Custom Field will capture this information in the 'Respondent Data' as part of the Signup but will not sync this information to a member's profile.";

const Container = styled(FnrVerticalGap)`
  overflow: hidden;
`;

const AddFieldSelect = () => {
  const defaultFields = extendedFieldHooks.useDefaultFields();
  const fieldSelectData = extendedFieldHooks.useFieldSelectData();
  const hasExtendedFields = extendedFieldHooks.useHasExtendedFields();
  const [fullWidth] = extendedFieldHooks.useDisplayIsFullWidth();
  const isSignupVariant = extendedFieldHooks.useVariant() === "signup";

  const hasDefaultField = defaultFields.length > 0;

  const [, setFieldData] = extendedFieldHooks.useFieldData();

  const handleFieldTypeSelect = (fieldData) => {
    setFieldData(fieldData);
  };

  const customData = extendedFieldHooks.useCustomData();

  return (
    <Container data-cy="ExtendedFields_AddFieldSelect_Container">
      {hasDefaultField ? (
        <FnrVerticalGap>
          <FnrVerticalGap gap={4}>
            <FnrTypography fontSize="xl">
              Add these to your profiles.
            </FnrTypography>
            <FnrTypography fontSize="sm" color="textSecondary">
              You can add these fields to your network.
            </FnrTypography>
          </FnrVerticalGap>
          <FnrOptionCards
            options={defaultFields}
            onSelect={handleFieldTypeSelect}
          />
        </FnrVerticalGap>
      ) : (
        <FnrTypography xMarginAdjust={8} fontSize="xl">
          Add a field
        </FnrTypography>
      )}
      {fieldSelectData.map(({ data, label, helperText }) => (
        <FnrAccordion key={label} label={label} helperText={helperText}>
          <FnrOptionCards options={data} onSelect={handleFieldTypeSelect} />
        </FnrAccordion>
      ))}
      <FnrAccordion
        label="Create a custom field"
        helperText={isSignupVariant ? customHelperText : undefined}
      >
        <FnrOptionCards options={customData} onSelect={handleFieldTypeSelect} />
      </FnrAccordion>
      {((!fullWidth && hasExtendedFields) || isSignupVariant) && <BackButton />}
    </Container>
  );
};

export default AddFieldSelect;
